import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ChevronLeftLarge from 'wix-ui-icons-common/ChevronLeftLarge';
import ChevronRightLarge from 'wix-ui-icons-common/ChevronRightLarge';
import YearDropdown from './YearDropdown';
import MonthDropdown from './MonthDropdown';
import styles from './styles.st.css';
import Text from '../../Text';

var getMonthName = function getMonthName(months, month) {
  return months[month] || months[0];
};

var DatePickerHead = function DatePickerHead(_ref) {
  var date = _ref.date,
      localeUtils = _ref.localeUtils,
      onChange = _ref.onChange,
      onLeftArrowClick = _ref.onLeftArrowClick,
      onRightArrowClick = _ref.onRightArrowClick,
      showMonthDropdown = _ref.showMonthDropdown,
      showYearDropdown = _ref.showYearDropdown;
  // We use global DayPicker-Nav--Left(--Right) class for consistency.
  // All styles of the DayPicker component are global and kept in ../DatePicker.scss
  return /*#__PURE__*/React.createElement("div", {
    "data-hook": "datepicker-head",
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.arrow, styles.arrowLeft, 'DayPicker-Nav--Left'),
    "data-hook": "datepicker-left-arrow",
    onClick: onLeftArrowClick
  }, /*#__PURE__*/React.createElement(ChevronLeftLarge, {
    className: styles.arrowIcon
  })), showMonthDropdown ? /*#__PURE__*/React.createElement(MonthDropdown, {
    date: date,
    onChange: onChange,
    months: localeUtils.getMonths()
  }) : /*#__PURE__*/React.createElement(Text, {
    className: styles.caption,
    weight: "normal",
    dataHook: 'datepicker-month-caption'
  }, getMonthName(localeUtils.getMonths(), date.getMonth())), showYearDropdown ? /*#__PURE__*/React.createElement(YearDropdown, {
    date: date,
    onChange: onChange
  }) : /*#__PURE__*/React.createElement(Text, {
    className: styles.caption,
    weight: "normal",
    dataHook: 'datepicker-year-caption'
  }, date.getFullYear()), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.arrow, styles.arrowRight, 'DayPicker-Nav--Right'),
    "data-hook": "datepicker-right-arrow",
    onClick: onRightArrowClick
  }, /*#__PURE__*/React.createElement(ChevronRightLarge, {
    className: styles.arrowIcon
  })));
};

DatePickerHead.propTypes = {
  date: PropTypes.object.isRequired,
  localeUtils: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onLeftArrowClick: PropTypes.func.isRequired,
  onRightArrowClick: PropTypes.func.isRequired,
  showMonthDropdown: PropTypes.bool,
  showYearDropdown: PropTypes.bool
};
export default DatePickerHead;